import { SynchTripImportDTO } from 'business/models/Models';
import React from 'react';
import { IStyle } from 'Styles';
import { csvColumnHeadings } from '../utils';

interface TableProps {
  tableData: SynchTripImportDTO[];
}

const styles: IStyle = {
  cell: {
    borderLeft: 'solid 1px Gainsboro',
    borderTop: '0px',
    whiteSpace: 'nowrap',
    lineHeight: '11px',
    fontSize: '12px',
  },

  validcell: {
    borderTop: '0px',
    color: 'green',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    lineHeight: '11px',
  },

  errorcell: {
    borderTop: '0px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    lineHeight: '11px',
  },

  errorrow: {
    backgroundColor: 'red',
  },

  table: {
    borderCollapse: 'collapse',
  },

  thead: {
    background: 'Gainsboro',
    position: 'sticky',
    top: 0,
    zIndex: 9999,
    borderTop: '0px',
  },

  row: { border: 'none', fontSize: '13px' },
};

function SynchTripVerificationTable({ tableData }: TableProps) {
  // get table column

  const columnsToDisplay = [
    'status',
    'synchTripId',
    'synchTripName',
    'dataCollectionDate',
    'crystalId',
    'crystalName',
    'puckName',
    'puckPinPosition',
    'dewarId',
    'dewarName',
  ];

  // get table heading data
  const thData = () => {
    return columnsToDisplay.map((data) => {
      return (
        <th
          id={`synchtripverificationtable-main-table-head-row-${data}`}
          style={{
            whiteSpace: 'nowrap',
          }}
          key={data}
        >
          {csvColumnHeadings[data]}
        </th>
      );
    });
  };

  // get table row data
  const tdData = () => {
    const tableDataMap = tableData.map((trip: SynchTripImportDTO, row) => {
      return (
        <tr
          id={`synchtripverificationtable-main-table-body-row-${row}`}
          style={trip.errorMessage ? styles.errorrow : null}
          key={row}
        >
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-message`}
            style={trip.errorMessage ? styles.errorcell : styles.validcell}
            title={trip.errorMessage}
          >
            {trip.errorMessage ? 'Error' : 'Valid'}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-synchtripid`}
            style={styles.cell}
          >
            {trip.synchTripId}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-synchtripname`}
            style={styles.cell}
          >
            {trip.synchTripName}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-datacollectiondate`}
            style={styles.cell}
          >
            {trip.dataCollectionDate ? trip.dataCollectionDate.toLocaleDateString() : ''}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-crystalid`}
            style={styles.cell}
          >
            {trip.crystalId}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-crystalname`}
            style={styles.cell}
          >
            {trip.crystalName}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-puckname`}
            style={styles.cell}
          >
            {trip.puckName}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-puckpinposition`}
            style={styles.cell}
          >
            {trip.puckPinPosition}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-dewarid`}
            style={styles.cell}
          >
            {trip.dewarId}
          </td>
          <td
            id={`synchtripverificationtable-main-table-body-row-${row}-dewarname`}
            style={styles.cell}
          >
            {trip.dewarName}
          </td>
        </tr>
      );
    });

    return tableDataMap;
  };

  return (
    <table
      id="synchtripverificationtable-main-table"
      className="table"
      style={styles.table}
    >
      <thead id="synchtripverificationtable-main-table-head" style={styles.thead}>
        <tr id="synchtripverificationtable-main-table-head-row" style={styles.row}>
          {thData()}
        </tr>
      </thead>
      {tableData.length && (
        <tbody id="synchtripverificationtable-main-table-body">{tdData()}</tbody>
      )}
    </table>
  );
}
export default SynchTripVerificationTable;
